// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ML_q","colBig":"styles_colBig__EQVU3","colSmall":"styles_colSmall__ZQ9In"};